import evalList       from '@/pages/createEval/evalList'
import createEval       from '@/pages/createEval/createEval'
import orgList       from '@/pages/createEval/orgList'
export default [
    {
        path: '/evalList',
        name: 'evalList',
        component: evalList,
    },
    {
        path: '/createEval',
        name: 'createEval',
        component: createEval,
    },
    {
        path: '/orgList',
        name: 'orgList',
        component: orgList,
    }
]
